/* @flow */

import * as React from 'react';

export default function useJSClass() {
  React.useEffect(() => {
    const htmlElt = document.documentElement;

    if (htmlElt) {
      htmlElt.classList.add('js');
    }
  }, []);
}
